import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import FemaleIcon from '@mui/icons-material/Female';
import MaleIcon from '@mui/icons-material/Male';
import WcIcon from '@mui/icons-material/Wc';

const getGenderStyles = (mode) => ({
  male: {
    bgcolor: mode === 'dark' ? 'rgba(37, 99, 235, 0.18)' : '#DBEAFE',
    color: mode === 'dark' ? '#93C5FD' : '#1D4ED8',
    iconColor: mode === 'dark' ? '#60A5FA' : '#2563EB',
    Icon: MaleIcon,
    label: 'Male',
  },
  female: {
    bgcolor: mode === 'dark' ? 'rgba(219, 39, 119, 0.18)' : '#FCE7F3',
    color: mode === 'dark' ? '#F9A8D4' : '#BE185D',
    iconColor: mode === 'dark' ? '#F472B6' : '#DB2777',
    Icon: FemaleIcon,
    label: 'Female',
  },
  other: {
    bgcolor: mode === 'dark' ? 'rgba(148, 163, 184, 0.16)' : '#F3F4F6',
    color: mode === 'dark' ? '#CBD5E1' : '#6B7280',
    iconColor: mode === 'dark' ? '#94A3B8' : '#6B7280',
    Icon: WcIcon,
    label: 'Other',
  },
});

const UserGenderBadge = ({ gender }) => {
  const theme = useTheme();
  const genderStyles = getGenderStyles(theme.palette.mode);
  const normalized = String(gender ?? '')
    .trim()
    .toLowerCase();
  const style = genderStyles[normalized];

  if (!style) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  const Icon = style.Icon;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1.1,
        py: 0.35,
        borderRadius: '999px',
        bgcolor: style.bgcolor,
        color: style.color,
        fontSize: '0.8125rem',
        fontWeight: 600,
        lineHeight: 1.4,
      }}
    >
      <Icon sx={{ fontSize: 15, color: style.iconColor }} />
      {style.label}
    </Box>
  );
};

export default UserGenderBadge;
